(function() {
    'use strict';

a3_cabin_reports.factory('PhotoFactory', PhotoFactory);

     /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name PhotoFactory
    * @description 
    *   Manage Report's Photos.
    * @ngInject
    */   
function PhotoFactory(GenericModalFactory) {

        /**
         * Initialiaze Photo object 
         * @memberof PhotoFactory
         */
		function Photo() {
			this.Id = null;
			this.Remarks = null;
			this.RemarksShort = null;
			this.PhotoData = null;
			this.FileType = null;
		}

		var service = {
			createNew : createNew,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			deleteFromList : deleteFromList
		}

        /**
         * Create a new Photo object 
         * @memberof PhotoFactory
         * @returns {object} Photo
         */		
		function createNew() {
			return GenericModalFactory.createNew(Photo)
		}

        /**
         * Extend given Photo object 
         * @memberof PhotoFactory
         * @param {object} obj The Photo object that will be extended
         * @returns {object} Photo
         */  
		function fromObject(obj) {
			return GenericModalFactory.fromObject(obj,Photo)
		}

        /**
         * Delete Photo object from given list
         * @memberof PhotoFactory
         * @param {object} obj The Photo object that will be deleted
         * @returns {array} Photos
         */
		function deleteFromList(obj, objList) {
			return GenericModalFactory.deleteFromList(obj, objList)
		}
		
        /**
         * Extend given Photo object 
         * @memberof PhotoFactory
         * @param {object} obj The Photo object that will be extended
         * @returns {object} Photo
         */  
		function fromObjectList(objList) {
			return GenericModalFactory.fromObjectList(objList,Photo)
		}

		return service;
	}

})();